import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["tagName", "aria-level"];
import { Heading } from '../Heading/Heading';
import { jsx as _jsx } from "react/jsx-runtime";
export const H2 = _ref => {
  let {
      tagName = 'h2',
      'aria-level': ariaLevel = 2
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Heading, Object.assign({
    tagName: tagName,
    "aria-level": ariaLevel
  }, restProps));
};
H2.displayName = 'H2';